import { ApprovingInvoiceReportsSearchRefetch } from '@/context/services/approving_invoice_reports/type';
import { useCallback } from 'react';

/**
 * We are using the api list approving reports to check if the user has permission to access the approving reports protected resources
 * if status return 403 or 401, we will reload the page
 * Check if the user has permission to access the approving reports protected resources
 */

const ForbiddenStatusCode = [403, 401];

export const useCheckApprovingReportsProtectedResources = () => {
  const handleCheckPermission = useCallback(
    async ({
      fnCheckPermission,
      onCheckSuccess,
      onCheckFailure,
    }: {
      fnCheckPermission?: ApprovingInvoiceReportsSearchRefetch;
      onCheckSuccess: () => void;
      onCheckFailure: () => void;
    }) => {
      try {
        if (!fnCheckPermission) return;
        const result = await fnCheckPermission();
        if (
          result?.data &&
          ForbiddenStatusCode.includes(result?.data?.status)
        ) {
          /** This means the user does not have permission to access the approving reports pages */
          onCheckFailure();
        } else {
          /** This means the user has permission to access the approving reports pages but not the current report */
          onCheckSuccess();
        }
      } catch {
        /** This means the user does not have permission to access the approving reports pages */
        onCheckFailure();
      }
    },
    []
  );

  return {
    handleCheckPermission,
  };
};
